<section class="wraper-sub">
  <div class="lead-m">
    <div class="top-page-m">
      <div class="top-section">
        <h1 class="page-name">Generate Ai Subscription Link</h1>
      </div>
      <div class="filter-sub-m">
        <div class="filter-m">
          <div class="filter">
            <div class="fields-m largeField">
              <input type="text" name="email" [(ngModel)]="aiSubscriptionLink.email"  placeholder="Insert User Email">
            </div>
          </div>
          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                [items]="aiSiteList"
                bindLabel="label"
                bindValue="value"
                placeholder="Select Site"
                [(ngModel)]="aiSubscriptionLink.site_link"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="false"
                (change)="get_plans()"
              ></ng-select>
            </div>
          </div>
          <div class="filter" *ngIf="plans.length">
            <div class="fields-m select-m">
              <ng-select
                [items]="plans"
                bindLabel="label"
                bindValue="value"
                placeholder="Select Plan"
                [(ngModel)]="aiSubscriptionLink.plan_id"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="false"
              ></ng-select>
            </div>
          </div>
          <div class="generate-m">
            <div class="link-m" (click)="generate_subscription_link()">
              <span>Generate</span>
            </div>
          </div>
          <div class="clear-m">
            <div class="clear" (click)="clearFilters()">
              <span>Clear</span>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.502 14.4612L11 14.5L16.3175 8.9606C16.7574 8.50197 16.9996 7.89224 16.9996 7.24366C16.9996 6.59515 16.7574 5.98539 16.3175 5.52676L12.178 1.21004C11.2701 0.263319 9.79293 0.263319 8.88506 1.21004L0.682059 9.76415C0.242217 10.2228 0 10.8325 0 11.4811C0 12.1296 0.242217 12.7394 0.682059 13.198L2.74371 15.3479C2.83711 15.4453 2.96378 15.5 3.09586 15.5H16.502C16.777 15.5 17 15.2675 17 14.9806C17 14.6938 16.777 14.4612 16.502 14.4612ZM7.83365 3.77541L9.14441 5.14226L5.12739 9.33125L3.81663 7.96439L7.83365 3.77541ZM11.8424 7.95567L7.82531 12.1446L5.8317 10.0657L9.84874 5.87674L11.8424 7.95567ZM12.5467 8.69015L13.8575 10.057L12.5138 11.4583L9.84048 14.246L8.52965 12.8791L12.5467 8.69015ZM9.58943 1.94452C10.1089 1.40283 10.9542 1.40283 11.4737 1.94452L15.6132 6.26124C16.1327 6.80297 16.1327 7.68442 15.6132 8.22612L14.5618 9.32256L8.53798 3.04093L9.58943 1.94452ZM1.38636 12.4635C1.13468 12.2011 0.996094 11.8521 0.996094 11.4811C0.996094 11.11 1.13468 10.7611 1.38633 10.4987L3.11226 8.69887L4.77514 10.4329L7.47309 13.2464L8.63816 14.4612H3.30215L1.38636 12.4635Z" fill="#1C212D"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="content" *ngIf=" url != ''">
    <div class="content-header">
      <i class="fa fa-copy copy-icon" (click)="copyText()"></i>
    </div>
    <div class="content-text" >
      <p>{{url}}</p>
    </div>
  </div>
</section>
